import type { LocaleMap } from '@hultafors/shared/types';

import { SiteLocale } from '@hultafors/hultaforsgroup/types';

export const localeMap: LocaleMap<SiteLocale> = new Map<string, SiteLocale>([
  ['da-dk', SiteLocale.Da],
  ['de-at', SiteLocale.DeAt],
  ['de-ch', SiteLocale.DeCh],
  ['de-de', SiteLocale.De],
  ['en-gb', SiteLocale.EnGb],
  ['en-ie', SiteLocale.EnIe],
  ['en', SiteLocale.En],
  ['fi-fi', SiteLocale.Fi],
  ['fr-ch', SiteLocale.FrCh],
  ['fr-fr', SiteLocale.FrFr],
  ['it-it', SiteLocale.ItIt],
  ['nb-no', SiteLocale.No],
  ['nl-be', SiteLocale.NlBe],
  ['nl-nl', SiteLocale.NlNl],
  ['pl-pl', SiteLocale.PlPl],
  ['sv-se', SiteLocale.Sv],
]);
